// Testimonials — scroll reveal via IntersectionObserver
(function(){
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.tm-reveal').forEach(function(el){ el.classList.add('tm-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){
        en.target.classList.add('tm-visible');
        io.unobserve(en.target);
      }
    });
  },{threshold:0.12});
  document.querySelectorAll('.tm-reveal').forEach(function(el){ io.observe(el); });
})();
